<template>
  <div id="contact">
    <div class="contactSection">
      <div class="Address">
        <div>
          <h1>Get In Touch</h1>
          <a href="">+255 756 676 345 </a><br />
          <a href="">info@kwanzaafresh.com</a>
        </div>
        <div class="image">
          <a href="" target="_blank"
            ><img src="../assets/icons/facebook-black.png"
          /></a>
          <a href="" target="_blank"
            ><img src="../assets/icons/instagram-black.png"
          /></a>
          <a href="" target="_blank"
            ><img src="../assets/icons/twitter-black.png"
          /></a>
        </div>
        <div class="bottomSection">
          <h2>Partner With Us</h2>
          <p>
            Are you a milk outgrower? Or looking to buy milk? Fill out our
            contact form and we will be in touch.
          </p>
        </div>
      </div>
      <div class="contactForm">
        <form action="">
          <table>
            <tr>
              <td>
                <input type="text" name="" placeholder="Name" />
              </td>
            </tr>
            <tr>
              <td>
                <input type="text" name="" placeholder="Phone Number" />
              </td>
            </tr>
            <tr>
              <td>
                <input type="text" name="" placeholder="Email" />
              </td>
            </tr>
            <tr>
              <td>
                <textarea type="text" placeholder="Message"> </textarea>
              </td>
            </tr>
            <tr>
              <td>
                <button>Submit</button>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/layouts/Footer";
export default {
  components: {
    Footer,
  },
};
</script>

<style scoped>
#contact {
  background-image: url("../assets/Contact/contact-bg.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  max-width: 1400px;
  margin: auto;
}
.contactSection {
  padding: 100px 0px 100px 0px;
  width: 80%;
  margin: auto;
}
table {
  width: 100%;
}
form input,
textarea {
  padding: 10px;
  margin-top: 20px;
  box-sizing: border-box;
  height: 40px;
  width: 100%;
  border-radius: 30px;
  border: 1px solid #343540;
}
textarea {
  height: 126px;
  resize: none;
}
button{
  margin-top: 10px;
  border: none;
  width: 125px;
  height: 40px;
  color: #FFF;
  font-size: 16px;
  line-height: 21px;
  border-radius: 30px;
  background-color: #0077B6;
}
form {
  width: 100%;
  /* background-color: aqua; */
}
.contactSection {
  display: flex;
}
h1 {
  font-family: "DM Sans";
  color: #343540;
  font-size: 36px;
  font-weight: 700;
  line-height: 47px;
}
h2 {
  color: #343540;
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}
.bottomSection p {
  color: #343540;
  font-family: "DM Sans";
  font-size: 14px;
  line-height: 18px;
  max-width: 260px;
}
.Address {
  display: grid;
}
.Address,
.contactForm {
  width: 100%;
}
#nav a {
  color: #343540;
  font-family: "DM Sans";
  font-size: 14px;
  line-height: 18px;
}
.image a {
  margin-right: 20px;
}
@media screen and (max-width: 720px) {
  .contactSection {
    display: grid;
    place-items: center;
  }
  .bottomSection p {
    max-width: 90%;
  }
  .image {
    margin-top: 20px;
  }
}
</style>